import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Hourglass, MessageCircle, Check, Trash2 } from "lucide-react";
import api from "../../api";

const br = (d) => d.split("-").reverse().join("/");
const msg = (w) => `Olá, ${(w.user_name || "").split(" ")[0]}! Abriu uma vaga em ${br(w.date)} para ${w.service_title} no Arya Studio K&C. Agende pelo site o quanto antes, a vaga é de quem agendar primeiro!`;

export default function WaitlistCard() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/waitlist").then(r => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const notify = async (w) => {
    if (!w.phone) return toast.error("Cliente sem telefone cadastrado");
    const phone = String(w.phone).replace(/\D/g, "");
    window.open(`https://wa.me/${phone.startsWith("55") ? phone : "55" + phone}?text=${encodeURIComponent(msg(w))}`, "_blank");
    await api.post(`/admin/waitlist/${w.wait_id}/notified`);
    load();
  };
  const remove = async (id) => {
    if (!window.confirm("Remover da lista de espera?")) return;
    await api.delete(`/admin/waitlist/${id}`); load();
  };

  return (
    <div className="card-arya p-5 mb-4" data-testid="admin-waitlist-card">
      <div className="flex items-center gap-2 mb-3">
        <Hourglass size={16} className="text-[color:var(--sun-600)]"/>
        <h3 className="font-serif text-xl">Lista de espera</h3>
        <span className="tag-sun ml-auto" data-testid="waitlist-vacancy-count">{items.filter(w => w.vacancy).length} com vaga aberta</span>
      </div>
      {items.length === 0 ? <p className="text-sm text-[color:var(--ink-500)]" data-testid="admin-waitlist-empty">Ninguém na lista de espera.</p> : (
        <ul className="divide-y divide-[var(--line)] text-sm">
          {items.map(w => (
            <li key={w.wait_id} className="py-3 flex flex-wrap items-center justify-between gap-3" data-testid={`admin-waitlist-${w.wait_id}`}>
              <div>
                <p className="font-display font-semibold">{w.user_name} <span className="font-normal text-[color:var(--ink-500)]">· {br(w.date)} · {w.service_title}</span></p>
                <p className={`text-xs ${w.vacancy ? "text-[#2F6B3C] font-semibold" : "text-[color:var(--ink-500)]"}`}>{w.vacancy ? "Vaga aberta!" : "Dia ainda lotado"} · {w.phone || "sem telefone"}</p>
              </div>
              <div className="flex items-center gap-2">
                {w.vacancy && (
                  <button onClick={() => notify(w)} className={`${w.notified_at ? "btn-ghost" : "btn-gold"} !py-1 !px-3 text-xs inline-flex items-center gap-1`} data-testid={`waitlist-notify-${w.wait_id}`}>
                    {w.notified_at ? <><Check size={12}/> Avisada</> : <><MessageCircle size={12}/> Avisar</>}
                  </button>
                )}
                <button onClick={() => remove(w.wait_id)} className="p-1.5 text-[color:var(--danger)]" data-testid={`waitlist-remove-${w.wait_id}`}><Trash2 size={14}/></button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
